<template>
  <div>
    <v-container
      fluid
      class="fill-height"
    >
      <v-row>
        <v-col class="pt-0">
          <v-progress-linear
            indeterminate
            height="2"
            v-if="fetching"
          ></v-progress-linear>
          <template v-else-if="delivery">
            <v-row>
              <v-col
                cols="12"
                md="8"
                lg="9"
              >
                <general-details :delivery="delivery" />
                <delivery-items :delivery="delivery" />
                <delivery-totals :delivery="delivery" />
                <notes
                  :parentId="delivery._id"
                  :parentType="'delivery'"
                  :add="createNote"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                lg="3"
              >
                <v-card flat>
                  <v-toolbar
                    dense
                    flat
                  >
                    <v-toolbar-title>פעולות</v-toolbar-title>
                  </v-toolbar>
                  <v-divider />
                  <v-list nav>
                    <template v-for="(item) in actionsMenu">
                      <v-list-item
                        :key="item.title"
                        @click="envokeMethodByName(item.action)"
                        v-if="item.viewIf ? propertByName(item.viewIf) : true"
                        class="ma-0"
                      >
                        <v-list-item-avatar>
                          <v-progress-circular
                            indeterminate
                            :size="20"
                            :width="2"
                            color="primary"
                            v-if="propertByName(item.loading) || false"
                          ></v-progress-circular>
                          <v-icon
                            v-else
                            :color="item.color"
                          >{{ item.icon }}</v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title><span :class="`${item.color}--text`">{{ item.title }}</span></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <v-alert
            :value="true"
            color="white"
            class="grey--text"
            icon="mdi-information-outline"
            v-else
          >
            נתוני משלוח לא נמצאו. נסו לטעון את הדף מחדש
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
    <delivery-has-arrived-dialog
      :active="isDeliveryHasArrivedDialogActive"
      :stores="stores"
      :delivery-id="deliveryId"
    />
  </div>
</template>

<script>
import Notes from "@/components/notes/Notes";
import GeneralDetails from "@/components/deliveries/GeneralDetails";
import DeliveryItems from "@/components/deliveries/DeliveryItems";
import DeliveryTotals from "@/components/deliveries/DeliveryTotals";
import DeliveryHasArrivedDialog from "@/components/deliveries/DeliveryHasArrivedDialog";
import { format } from "date-fns";
import generateId from "@/idGenerator";
import mixins from "@/mixins/mixins";
import { getApi } from "@/api";

export default {
  data() {
    return {
      tab: null,
      fetching: true,
      removing: false,
      sendingDelivery: false,
      settingAsCompleted: false,
      settingIsReady: false,
      isDeliveryHasArrivedDialogActive: false,
      actionsMenu: [
        {
          icon: "mdi-plus",
          color: "primary",
          title: "הוספת פריט",
          action: "createDeliveryItem",
          viewIf: "isNotReady"
        },
        {
          icon: "mdi-printer",
          color: "primary",
          title: "הדפסת תעודת משלוח",
          action: "createNote"
        },
        {
          icon: "mdi-check",
          color: "primary",
          title: "המשלוח מוכן",
          action: "toggleIsReady",
          loading: "settingIsReady",
          viewIf: "isNotReady"
        },
        {
          icon: "mdi-truck-delivery",
          color: "primary",
          title: "העברה לשליח",
          action: "sendDelivery",
          loading: "sendingDelivery",
          viewIf: "notSentYet"
        },
        {
          icon: "mdi-truck-check",
          color: "primary",
          title: "דיווח על הגעה ליעד",
          action: "showDeliveryHasArrivedDialog",
          viewIf: "sentNotArrived"
        },
        {
          icon: "mdi-pencil",
          color: "primary",
          title: "עריכת פרטים",
          action: "edit"
        },
        {
          icon: "mdi-delete",
          color: "red",
          title: "מחיקה",
          action: "remove",
          loading: "removing"
        }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    deliveryId() {
      return this.$route.params.id;
    },
    delivery() {
      return this.$store.getters["entity"]("deliveries", this.deliveryId);
    },
    isNotReady() {
      return (
        !this.delivery.isReady &&
        !this.delivery.isDeliveredToTempStore &&
        !this.delivery.isDeliveredToFinalStore
      );
    },
    notSentYet() {
      return (
        this.delivery.isReady &&
        !this.delivery.isDeliveredToTempStore &&
        !this.delivery.isDeliveredToFinalStore
      );
    },
    sentNotArrived() {
      return (
        this.delivery.isDeliveredToTempStore &&
        !this.delivery.isDeliveredToFinalStore
      );
    },
    deliveryItems() {
      return Object.values(this.$store.state.entities.deliveryItems)
        .filter(item => {
          return item.delivery && item.delivery === this.delivery._id;
        })
        .sort((a, b) => {
          return a.store < b.store ? -1 : 1;
        });
    },
    stores() {
      let storesMap = {};
      for (let deliveryItem of this.deliveryItems) {
        let store = deliveryItem.store;
        if (store) {
          storesMap[store] = true;
        }
      }
      // console.log(storesMap);
      return Object.keys(storesMap).map(item => {
        return this.$store.state.entities.stores[item];
      });
    },
    deliveryHasArrivedDialog: {
      get() {
        return this.$store.state.deliveryHasArrivedDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_DELIVERY_HAS_ARRIVED_DIALOG", isActive);
      }
    }
  },
  methods: {
    format,
    propertByName(name) {
      return this[name];
    },
    envokeMethodByName(name) {
      this[name]();
    },
    toggleIsReady() {
      this.settingIsReady = true;
      let params = {
        isReady: !this.delivery.isReady
      }
      getApi()
        .then(api => {
          return api.patch(`/deliveries/${this.deliveryId}`, params);
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.settingIsReady = false;
        });
    },
    edit() {
      this.editDelivery(this.delivery);
    },
    remove() {
      this.$root.$confirm("האם למחוק את המשלוח?").then(res => {
        if (!res) {
          return;
        }

        let id = this.delivery._id;

        this.removing = true;
        this.$store
          .dispatch("REMOVE_ENTITY", {
            url: "/deliveries",
            entityType: "deliveries",
            id
          })
          .then(() => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: "הפריט נמחק",
              color: "success"
            });
            this.$router.go(-1);
          })
          .catch(err => {
            console.log(err.stack);
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.removing = false;
          });
      });
    },
    editDelivery(entity, isNew = false) {
      let resource = this.$store.state.resources.delivery;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    },
    fetch() {
      this.fetching = true;
      this.$store
        .dispatch("API_GET", {
          url: "/deliveries/" + this.deliveryId,
          entityType: "deliveries",
          schema: "deliveryListSchema",
          params: {
            limit: 0
          }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    createDeliveryItem() {
      let newEntity = {
        _id: generateId(),
        delivery: this.delivery._id,
        user: this.user._id
      };
      let resource = this.$store.state.resources.deliveryItem;
      this.editEntity(newEntity, resource, true);
    },
    createNote() {
      let newEntity = {
        _id: generateId(),
        delivery: this.delivery._id,
        user: this.user._id
      };
      let resource = this.$store.state.resources.note;
      this.editEntity(newEntity, resource, true);
    },
    sendDelivery() {
      this.$root.$confirm("האם לבצע הוצאת משלוח?").then(res => {
        if (!res) {
          return;
        }

        this.sendingDelivery = true;
        getApi()
          .then(api => {
            return api.post(`/deliveries/${this.deliveryId}/send`);
          })
          .catch(err => {
            this.showError(err);
          })
          .finally(() => {
            this.sendingDelivery = false;
          });
      });
    },
    showDeliveryHasArrivedDialog() {
      this.deliveryHasArrivedDialog = true;
    }
  },
  mounted() {
    this.fetch();
  },
  watch: {

  },
  components: {
    GeneralDetails,
    DeliveryItems,
    DeliveryTotals,
    DeliveryHasArrivedDialog,
    Notes
  },
  mixins: [mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
